// extracted by mini-css-extract-plugin
export var addToCartButton = "_o0-b";
export var arrowButtonContainer = "_o0-9";
export var arrowButtonIcon = "_o0-a";
export var carouselArrowButton = "_o0-6";
export var carouselElementContainer = "_o0-1";
export var left = "_o0-7";
export var productDisplayCarouselContainer = "_o0-0";
export var productTileContainer = "_o0-2";
export var productTileImage = "_o0-4";
export var productTileImageContainer = "_o0-3";
export var productTileTitle = "_o0-5";
export var right = "_o0-8";
export var sliderOverflow = "_o0-c";